import { useQuery } from "@tanstack/react-query";
import type { AuthedUser } from "@march/shared";
import { apiGet } from "../lib/api.ts";

/**
 * Loads the current user from GET /api/me. Cached for the session —
 * role decides whether admin nav appears.
 */
export function useMe() {
  return useQuery<AuthedUser>({
    queryKey: ["me"],
    queryFn: async () => (await apiGet<{ user: AuthedUser }>("/api/me")).user,
    staleTime: 60 * 60_000, // 1 hour — role changes are rare
  });
}
